import { render, staticRenderFns } from "./SentimentTrendChart.vue?vue&type=template&id=5fb414eb&scoped=true"
import script from "./SentimentTrendChart.vue?vue&type=script&lang=js"
export * from "./SentimentTrendChart.vue?vue&type=script&lang=js"
import style0 from "./SentimentTrendChart.vue?vue&type=style&index=0&id=5fb414eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb414eb",
  null
  
)

export default component.exports